import React from "react";
import PropTypes from "prop-types";
import { Checkbox, Label, List } from "semantic-ui-react";

const DELIVERY_LABELS = {
  PICKUP: "Library Use",
  DELIVERY: "Home Use",
  "SELF-CHECKOUT": "Self-checkout",
  pickup: "Library Use",
  delivery: "Home Use",
  "self-checkout": "Self-checkout",
  "on shelf": "On Shelf",
};

// Known acronyms and special cases
const ACRONYM_LABELS = {
  CDROM: "CD-ROM",
  DVD: "DVD",
  VHS: "VHS",
  "E-BOOK": "E-Book",
  EBOOK: "E-Book",
};

const getDisplayLabel = (key) => {
  if (DELIVERY_LABELS[key]) {
    return DELIVERY_LABELS[key];
  }

  // Normalize to uppercase for lookup in acronym map
  const upperKey = key
    .toUpperCase()
    .replaceAll(" ", "")
    .replaceAll("-", "")
    .replaceAll("_", "");
  if (ACRONYM_LABELS[upperKey]) {
    return ACRONYM_LABELS[upperKey];
  }

  // Default formatting
  return (
    key.charAt(0).toUpperCase() +
    key.slice(1).replaceAll("_", " ").toLowerCase()
  );
};

export const CardBucketAggregationValueElementOverrides = ({
  bucket,
  isSelected,
  onFilterClicked,
  childAggCmps,
  overridableId,
  valueLabel,
}) => {
  const key = bucket.key_as_string ? bucket.key_as_string : bucket.key;
  const label = getDisplayLabel(key);
  return (
    <List.Item key={bucket.key}>
      <List.Content floated="right">
        <Label>{bucket.doc_count}</Label>
      </List.Content>
      <List.Content>
        <Checkbox
          label={label}
          value={key}
          onClick={() => onFilterClicked(key)}
          checked={isSelected}
        />
        {childAggCmps && childAggCmps}
      </List.Content>
    </List.Item>
  );
};

CardBucketAggregationValueElementOverrides.propTypes = {
  bucket: PropTypes.object.isRequired,
  isSelected: PropTypes.bool,
  onFilterClicked: PropTypes.func.isRequired,
  childAggCmps: PropTypes.node,
  overridableId: PropTypes.string,
  valueLabel: PropTypes.string,
};

CardBucketAggregationValueElementOverrides.defaultProps = {
  isSelected: false,
  overridableId: "",
  valueLabel: null,
  childAggCmps: null,
};
